<template>
  <div
    :class="[$.select, $.sort_by]"
  >
    <template v-if="isBoardConfigLoading">
      <skeleton-item
        type="bar"
        :style="{ height: '24px', width: '116px', marginRight: 0 }"
      />
    </template>
    <template
      v-else
    >
      <icon-button
        v-if="canRefresh"
        :icon="{ name:'update', size: 20 }"
        :colors="iconButtonColors"
        :active="true"
        :class="$.sort_refresh"
        @onClick="refreshSort"
      />
      <div
        :class="[
          $.picker,
          canRefresh ? $.can_refresh : '',
          isContextOpened || canRefresh ? $.active : ''
        ]"
        @click.stop="({ currentTarget }) => toggleContextMenu(currentTarget)"
      >
        <div
          :class="$.label"
        >
          {{ label }}
        </div>
        <div
          :class="$.active"
        >
          {{ sortName }}
        </div>
        <div
          :class="$.clear_icon"
          v-if="isClearButton"
          @click.stop="clearSort"
          @mouseenter="closeButtonType = 'bold'"
          @mouseleave="closeButtonType = 'regular'"
        >
          <svg-sprite
            name="close-5"
            :type="closeButtonType"
            :size="20"
          />
        </div>
        <div
          :class="$.side_icon"
          v-else
        >
          <svg-sprite
            :name="isContextOpened ? 'arrow-top' : 'arrow-down'"
            :type="'regular'"
            :size="20"
          />
        </div>
      </div>
    </template>

    <div
      v-if="sortName"
      :class="$.sort_icon"
      @click.stop="changeDirection"
    >
      <icon-button
        :icon="{ name: direction === 'ASC' ? 'priority' : 'priority-2', size: 20 }"
        :colors="iconButtonColors"
      />
    </div>
  </div>
</template>

<script>
import app from '../../../app';
import projects from '../../../models/projects';
import iconButton from '$$vueCmp/globalButton/withIcon/iconButton.vue';
import SkeletonItem from '../../common/VueComponents/skeletons/skeletonItem.vue';

export default {
  name: 'BoardSorting',
  components: {
    iconButton,
    SkeletonItem
  },
  data() {
    return {
      locale: __,
      closeButtonType: 'regular',
      iconButtonColors: {
        color: '#333333',
        activeColor: '#11519A',
        hoverBg: '#F2F2F2',
        activeBg: '#D0E0F2',
        activeHoverBg: '#A1C1E6'
      }
    };
  },
  computed: {
    isBoardConfigLoading() {
      return this.$store.getters['board/isLoading'];
    },
    contextMenus() {
      return this.$store.getters['board/contextMenus'];
    },
    ganttId() {
      return +projects.getActiveGanttId();
    },
    items() {
      return this.$store.getters['board/sortingFields'];
    },
    activeSort() {
      return this.items.find(item => item.isSortedBy);
    },
    sortName() {
      if (!this.activeSort) return '';

      return this.activeSort.name;
    },
    direction() {
      if (!this.activeSort) return '';

      return this.activeSort.direction;
    },
    label() {
      return this.locale('board_sort_by') + (this.sortName ? ': ' : ' ');
    },
    isClearButton() {
      return !this.isContextOpened && this.sortName;
    },
    isContextOpened() {
      return this.contextMenus.some(context => context.type === 'sort');
    },
    canRefresh() {
      return this.$store.getters['board/newTasksPool'].length && this.activeSort;
    }
  },
  methods: {
    toggleContextMenu(target = null) {
      this.$store.dispatch('board/setContextMenu', {
        item: {
          id: 'board_sort_by',
        },
        type: 'sort',
        menu: 'main',
        position: target?.getBoundingClientRect() || null,
        side: '',
      });
    },
    clearSort() {
      userExtAnalytics.log('header_select_board_sorting', {
        type: '',
      });

      this.$store.dispatch('board/setBoardConfig', {
        config: {
          ...this.$store.getters['board/currentConfig'],
          sorting: {
            values: [],
          },
        },
      });
      this.closeButtonType = 'regular';
    },
    changeDirection() {
      this.$store.dispatch('board/setBoardConfig', {
        config: {
          ...this.$store.getters['board/currentConfig'],
          sorting: {
            values: [{
              fieldId: this.activeSort.id,
              direction: ['ASC', 'DESC'].filter(i => i !== this.direction)[0],
            }],
          },
        },
      });
    },
    refreshSort() {
      app.trigger('board:sort:refresh');
    }
  },
};
</script>

<style module="$" src="../less/select.less"></style>
